module.exports = function() {
  return new Worker(__webpack_public_path__ + "0021e5e6aa55ddb65909.worker.js");
};